"use client";

import { useEffect } from "react";
import { scan } from "react-scan";

import { NODE_ENV } from "@workspace/shared/constants";

import { env } from "../../env.config";

export function ReactScan() {
  useEffect(() => {
    scan({
      enabled: env.NODE_ENV === NODE_ENV.DEVELOPMENT,
    });
  }, []);

  return null;
}
